/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React from "react";
import { useSiteMetadata } from "../../hooks/use-site-metadata";
function Seo({ title, description, pathname, children,videoSeo, keywords = [] }) {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    author: "KPOINT Technologies",
  };

  const getSchemaMarkup = () => {
    // If videoSeo is provided, use that
    if (videoSeo) {
      return JSON.stringify(videoSeo);
    }
    
    // Otherwise use the default Organization schema
    return `
      {
        "@context": "https://schema.org",
        "image": "${seo.image}",
        "@type": "Organization",
        "url": "${seo.url}",
        "name": "KPOINT Technologies",
        "logo": "${seo.image}",
        "description": "${seo.description}",
        "sameAs": [
          "https://www.linkedin.com/company/kpoint-technologies/",
          "https://www.instagram.com/kpoint.videofy/ ",
          "https://x.com/teamkpoint"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "020 4852 2626",
          "contactType": "Customer Experience"
        }
      }
    `;
  };

  return (
    <>
      <title>
        {defaultTitle ? `${seo.title} | ${defaultTitle}` : "KPOINT"}
      </title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      {keywords.length > 0 && (
  <meta name="keywords" content={keywords.join(", ")} />
)}
      <meta name="author" content={seo.author}></meta>
      <meta name="image" content={seo.image} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content="KPOINT Technologies Logo" />
      <meta property="og:image:width" content="1440" />
      <meta property="og:image:height" content="582" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content={seo.title} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={seo.author || ``} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta property="twitter:image" content={seo.image} />

      <link rel="canonical" href={seo.url} />

      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-KW0X3BFJG6"
      ></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-KW0X3BFJG6');
        `}
      </script>
      <script type="application/ld+json">
        {getSchemaMarkup()}
      </script>
      {children}
    </>
  );
}

export default Seo;
